import { useCurrency } from "@/lib/currency";
import { Banknote } from "lucide-react";

const CURRENCIES = [
  { code: "EUR", label: "EUR" },
  { code: "USD", label: "USD" },
  { code: "GBP", label: "GBP" },
  { code: "CHF", label: "CHF" },
  { code: "CAD", label: "CAD" },
  { code: "AUD", label: "AUD" },
  { code: "AED", label: "AED" },
  { code: "SAR", label: "SAR" },
  { code: "MAD", label: "MAD" },
];

export function CurrencySwitcher({ className = "" }: { className?: string }) {
  const { currency, setCurrency } = useCurrency();

  return (
    <div className={`relative inline-flex items-center ${className}`}>
      <Banknote className="pointer-events-none absolute left-2.5 h-4 w-4 text-muted-foreground" />
      <select
        aria-label="Currency"
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className="h-9 appearance-none rounded-full border border-border bg-background pl-8 pr-7 text-xs font-medium text-foreground hover:border-primary/40 focus:border-primary focus:outline-none"
      >
        {CURRENCIES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.label}
          </option>
        ))}
      </select>
      <span className="pointer-events-none absolute right-2 text-[10px] text-muted-foreground">▾</span>
    </div>
  );
}
